export const WA_NUMBER = "393508975700";
export const WA_DISPLAY = "+39 350 897 5700";
export const TIKTOK_URL = "https://www.tiktok.com/@atlante.viaggi";
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8f29339e-7e45-4957-979d-cce6b4094348/artifacts/1t2o4aur_fa5f26c1-a8f4-4ca0-9e70-5684dae7279c.png";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text || "Ciao Atlante Viaggi 👋, vorrei informazioni su un pacchetto.")}`;

export const waPackageMessage = (p) =>
  `Ciao Atlante Viaggi ✈️! Sono interessato/a al pacchetto *${p.destination} ${p.flag || ""}* (${p.nights}) a partire da €${Number(p.price).toFixed(2)}. Potete darmi maggiori informazioni? Grazie 🙏`;

export const formatPrice = (n) => {
  if (n == null) return "—";
  const num = Number(n);
  if (Number.isInteger(num)) return `€${num}`;
  return `€${num.toFixed(2).replace(".", ",")}`;
};
